module.exports = __webpack_public_path__ + "static/media/star.39c62f3e.png";